// extracted by mini-css-extract-plugin
module.exports = {"palo-logo":"desktopLogo-m__palo-logo__2aj3K","palo-english-logo":"desktopLogo-m__palo-english-logo__19QmC"};